<template>
  <validation-observer ref="refFormObserver">
    <b-form>
      <!-- <b-row class="mx-0">
        <b-col cols="6">
          <validation-provider
            #default="validationContext"
            name="delayed_record_minutes"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('camera.previous_time_of_prealarma')"
              label-for="delayed_record_minutes"
            >
              <flat-pickr
                id="delayed_record_minutes"
                class="form-control"
                :state="getValidationState(validationContext)"
                :config="{
                  enableTime: true,
                  dateFormat: 'H:i:S',
                  time_24hr: true,
                  noCalendar: true,
                  enableSeconds: true,
                }"
                v-model="itemData.delayed_record_minutes"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="6">
          <validation-provider
            #default="validationContext"
            name="forward_record_minutes"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('camera.later_time_of_prealarma')"
              label-for="forward_record_minutes"
            >
              <flat-pickr
                id="forward_record_minutes"
                class="form-control"
                :state="getValidationState(validationContext)"
                :config="{
                  enableTime: true,
                  dateFormat: 'H:i:S',
                  time_24hr: true,
                  noCalendar: true,
                  enableSeconds: true,
                }"
                v-model="itemData.forward_record_minutes"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row> -->
      <b-row class="mx-0">
        <b-col cols="12">
          <!-- Recording enabled -->
          <b-form-checkbox
            id="recording_enable"
            v-model="itemData.recording_enable"
            name="recording_enable"
            value="1"
            class="my-1 text-capitalize"
            unchecked-value="0"
            switch
          >
            {{ $t("camera_proxy.recording_enable") }}
          </b-form-checkbox>
        </b-col>
        <b-col cols="6">
          <!-- limits (Recording hours) -->
          <validation-provider #default="validationContext" name="rec_hours">
            <b-form-group
              v-show="itemData.recording_enable == 1"
              class="text-capitalize"
              :label="$t('camera_proxy.rec_hours')"
              label-for="rec_hours"
              :state="getValidationState(validationContext)"
            >
              <div class="container-btns-limit">
                <button
                  v-for="limit in limits"
                  :class="[
                    'btn-limits-normal',
                    { 'btn-limits-selected': localSelectedLimit == limit.value },
                  ]"
                  :key="limit.value"
                  :id="'btn-' + limit.value"
                  @click="selectLimit(limit.value)"
                  type="button"
                >
                  {{ $t("camera_proxy." + limit.label) }}
                </button>
                <div :name="btnlimit(itemData.record_limit)"></div>
              </div>
              <div v-if="localSelectedLimit === 0">
                <b-form-group class="text-capitalize" label-for="limitPer"></b-form-group>
                <div class="input-wrapper">
                  <b-input
                    id="limitPer"
                    :value="hoursToDays(itemData.record_limit)"
                    class="input-days"
                  />
                  <span class="days-label">{{ $t("camera_proxy.days") }}</span>
                </div>
              </div>
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import formValidation from "@core/comp-functions/forms/form-validation";
import vSelect from "vue-select";
import SelectPaginate from "@/views/components/SelectPaginate.vue";
import { ref, watch } from "@vue/composition-api";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    SelectPaginate,
    flatPickr,
  },
  props: {
    propItemData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    isAdd: {
      type: Boolean,
      required: false,
      default: false,
    },
    selectedLimit: {
      type: Number,
      required: false,
      default: null,
    },
  },
  setup(props, { emit }) {
    const { t } = useI18nUtils();
    const { refFormObserver, getValidationState } = formValidation();
    const itemData = ref(JSON.parse(JSON.stringify(props.propItemData)));

    const localSelectedLimit = ref(props.selectedLimit);

    const limits = [
      { label: "limit.3_days", value: 72 },
      { label: "limit.7_days", value: 168 },
      { label: "limit.14_days", value: 336 },
      { label: "limit.30_days", value: 720 },
      { label: "limit.60_days", value: 1440 },
      { label: "limit.90_days", value: 2160 },
      { label: "limit.180_days", value: 4320 },
      { label: "limit.1_year", value: 8760 },
      { label: "limit.2_years", value: 17520 },
      { label: "limit.custom", value: 0 },
    ];

    const selectLimit = (value) => {
      if (value === 0) {
        localSelectedLimit.value = value;
        itemData.value.record_limit = value;
      } else {
        itemData.value.record_limit = value;
      }
      emit("update:selectedLimit", value);
    };
    const btnlimit = (value) => {
      let selectedValue = limits.find((limit) => limit.value === value)?.value || 0;
      itemData.value.record_limit = selectedValue;
      localSelectedLimit.value = selectedValue;
      emit("update:selectedLimit", selectedValue);
    };

    const updateLimit = () => {
      this.itemData.record_limit = this.daysToHours(this.customDays);
    };

    const hoursToDays = (data) => {
      if (data == null) {
        return 0;
      }
      return Math.round(data / 24);
    };
    const daysToHours = (data) => {
      return data * 24;
    };

    const validateStep = () => {
      return refFormObserver.value.validate();
    };

    const setupWatcher = (itemData, key) => {
      watch(
        () => itemData.value[key],
        (newValue, oldValue) => {
          if (newValue !== oldValue) {
            emit("update:itemData", { [key]: newValue });
          }
        }
      );
    };

    watch(
      () => props.propItemData,
      (newValue) => {
        itemData.value = { ...newValue };
      },
      { deep: true }
    );

    setupWatcher(itemData, "record_limit");
    setupWatcher(itemData, "recording_enable");

    return {
      t,
      refFormObserver,
      getValidationState,
      validateStep,
      itemData,
      limits,
      selectLimit,
      updateLimit,
      hoursToDays,
      daysToHours,
      btnlimit,
      localSelectedLimit,
    };
  },
};
</script>
